/** Arborescence de navigation du site vitrine (source unique pour nav + footer). */

export interface NavLink {
  label: string;
  href: string;
  /** Court descriptif (menu mobile / footer). */
  hint?: string;
}

/** Liens affichés dans la barre de navigation desktop (condensée). */
export const NAV_PRIMARY: NavLink[] = [
  { label: 'Le Laboratoire', href: '/a-propos' },
  { label: 'Services', href: '/services' },
  { label: 'Matériaux', href: '/materiaux' },
  { label: 'Plateforme', href: '/plateforme' },
  { label: 'Processus', href: '/processus' },
];

/** Ensemble complet (menu mobile + footer). */
export const NAV_ALL: NavLink[] = [
  { label: 'Le Laboratoire', href: '/a-propos', hint: 'Notre histoire, notre vision' },
  { label: 'Services', href: '/services', hint: 'Couronnes, bridges, facettes…' },
  { label: 'Matériaux', href: '/materiaux', hint: 'Zircone, disilicate, céramiques' },
  { label: 'Pourquoi nous', href: '/pourquoi-nous', hint: 'Nos engagements qualité' },
  { label: 'Plateforme', href: '/plateforme', hint: 'Le flux de travail numérique' },
  { label: 'Processus', href: '/processus', hint: 'De la commande à la livraison' },
  { label: 'Partenaires', href: '/partenaires', hint: 'Nos marques de référence' },
  { label: 'Contact', href: '/contact', hint: 'Parlons de votre laboratoire' },
];

/** Accès à la plateforme opérationnelle (authentification requise). */
export const PRO_LOGIN_HREF = '/login';
/** « Devenir partenaire » → demande d'accès au portail dentiste. */
export const BECOME_PARTNER_HREF = '/register/dentist';
